import { meridioPlanCatalogService } from "./service";
import { IMeridioPlanCatalogResponse } from "./types";

export const getMeridioPlanCatalog =
  async (): Promise<IMeridioPlanCatalogResponse> => {
    const { data } = await meridioPlanCatalogService.get(``);
    return data;
  };
